module.exports = __webpack_public_path__ + "img/summarize_img6.png";